import { Label } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import React from 'react';

import { ThirdPartyShareWrapper } from './styled';

const getSocialShareIcons = ({ formName, formPath }) => ({
	LinkedIn: {
		link: `https://www.linkedin.com/shareArticle?mini=true&url=${formPath}&title=${formName}`,
		icon: 'https://storage.googleapis.com/fplsblog/share-icons/linkedin.svg'
	},
	Twitter: {
		link: `https://twitter.com/intent/tweet?text=${formName}%20-&url=${formPath}`,
		icon: 'https://storage.googleapis.com/fplsblog/share-icons/x.svg'
	},
	Telegram: {
		icon: 'https://storage.googleapis.com/fplsblog/share-icons/telegram.svg',
		link: `https://t.me/share/url?url=${formPath}&text=${formName}`
	},
	Whatsapp: {
		icon: 'https://storage.googleapis.com/fplsblog/share-icons/whatsapp.svg',
		link: `https://wa.me/?text=${formPath}`
	},
	Facebook: {
		icon: 'https://storage.googleapis.com/fplsblog/share-icons/facebook.svg',
		link: `http://www.facebook.com/sharer.php?u=${formPath}`
	},
	Email: {
		icon: 'https://storage.googleapis.com/fplsblog/share-icons/email.svg',
		link: `mailto:?subject=${formName}&body=${formPath}`
	},
	// Fallback for incoming work on FPL-1247
	X: {
		link: `https://x.com/intent/tweet?text=${formName}%20-&url=${formPath}`,
		icon: 'https://storage.googleapis.com/fplsblog/share-icons/x.svg'
	}
});

const ThirdPartyShare = ({ isBuilderPreview, socialOptions, viewport, formName }) => {
	if (!socialOptions.length) return null;

	const socialShareIcons = getSocialShareIcons({
		formPath: window.location.href,
		formName,
	});

	const builderPreviewClasses = [
		isBuilderPreview ? 'builder-preview' : '',
		viewport === 'web' ? 'desktop' : ''
	].join(' ');

	return (
		<ThirdPartyShareWrapper className={builderPreviewClasses}>
			<span className="share">
				<img src="https://storage.googleapis.com/fplsblog/share-icons/share.svg" alt="share_form" />
				Share form
			</span>

			{socialOptions.map((option) => (
				<div className="icon-wrapper" key={option}>
					<Label pointing="right" className="tooltip">{option}</Label>
					<a
						href={!isBuilderPreview ? socialShareIcons[option].link : null}
						rel="noopener noreferrer"
						target="_blank"
					>
						<img src={socialShareIcons[option].icon} alt={`${option.toLowerCase()}_icon`} />
					</a>
				</div>
			))}
		</ThirdPartyShareWrapper>
	)
};

ThirdPartyShare.defaultProps = {
	isBuilderPreview: false,
	viewport: 'web'
};

ThirdPartyShare.propTypes = {
	socialOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
	formName: PropTypes.string.isRequired,
	isBuilderPreview: PropTypes.bool,
	viewport: PropTypes.string
};

export default ThirdPartyShare;